import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";

// Data
import SectionInfo from "./components/SectionInfo";
import sectionService from "../../../services/sectionService";

function handleError(error) {
    if (error.response) {
        console.error("Server error:", error.response);
    } else if (error.request) {
        console.error("Network error:", error.request);
    } else {
        console.error("Error:", error.message);
    }
}

function DetailsPage() {
    let { id } = useParams();
    const [section, setSection] = useState({});
    //const [loading, setLoading] = useState(true);

    const fetchSection = useCallback(async () => {
        try {
            const response = await sectionService.getById(id);
            setSection(response.data);
            //setLoading(false);
        } catch (error) {
            handleError(error)
            //setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        fetchSection();
    }, [fetchSection]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox py={3}>
                <Card sx={{ overflow: "visible" }}>
                    <MDBox p={3}>
                        <MDBox mb={3}>
                            <MDTypography variant="h5" fontWeight="medium">
                                Información de la sección
                            </MDTypography>
                        </MDBox>

                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={5}>
                                <SectionInfo section={section} />
                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default DetailsPage;
